export const UNIQUE_REPORT_NAME = 'corporate-detailed-history';
